// /srv/agents_ui/app/src/hooks/useEventStream.ts
import { useEffect, useState } from "react";
import { resolveApiUrl } from "@/lib/api";

export interface SSEEvent {
  event: string;
  data: any;
}

export function useEventStream(onEvent?: (event: SSEEvent) => void, enabled = true) {
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    if (!enabled) {
      setConnected(false);
      return;
    }

    const url = resolveApiUrl("/events");
    const eventSource = new EventSource(url);

    eventSource.onopen = () => setConnected(true);
    eventSource.onerror = () => setConnected(false);

    const handler = (e: MessageEvent) => {
      const data = (() => {
        try {
          return JSON.parse(e.data);
        } catch {
          return e.data;
        }
      })();
      if (onEvent) onEvent({ event: e.type, data });
    };

    [
      "thread_update",
      "workflow_transition",
      "hitl_pending",
      "autopilot_trigger",
      "delegation",
      "memory_episode_added",
      "artist_bootstrap_progress",
      "artist_ingest_progress",
    ].forEach((eventName) => eventSource.addEventListener(eventName, handler));

    return () => {
      eventSource.close();
    };
  }, [onEvent, enabled]);

  return { connected };
}
